/* eslint-disable react/prop-types */
import React from 'react';
import { Button, Tooltip } from 'antd';

import {
  AimOutlined,
  CarOutlined,
  ClockCircleOutlined,
  ExpandOutlined,
  UserOutlined,
} from '@ant-design/icons';

import './MapControls.scss';

// Ícones personalizados para os botões de controle
function StartIcon() {
  return <div className="map-control-icon start-icon" />;
}

function EndIcon() {
  return <div className="map-control-icon end-icon" />;
}

function getOperatorIcon(operatorType) {
  if (operatorType?.toLowerCase().includes('driver')) {
    return <CarOutlined />;
  }
  return <UserOutlined />;
}

// Botões de controle do mapa com estilo nativo
function MapControls({
  onCenter,
  onCenterDestination,
  onFit,
  onToggleFullScreen,
  onCenterOperator,
  fitDisabled,
  routeDisabled,
  selectedOperator,
  isFullScreen = false,
  eta,
  isFollowingOperator,
}) {
  return (
    <div className="map-controls-wrapper">
      <div className="map-controls-horizontal">
        <Tooltip title="Focar Início" placement="bottom">
          <Button onClick={onCenter} disabled={routeDisabled} icon={<StartIcon />} />
        </Tooltip>
        <Tooltip title="Focar Destino" placement="bottom">
          <Button onClick={onCenterDestination} disabled={routeDisabled} icon={<EndIcon />} />
        </Tooltip>
        <Tooltip
          title={
            isFollowingOperator
              ? 'Parar de seguir'
              : `Seguir ${selectedOperator?.name || 'Operador'}`
          }
          placement="bottom"
        >
          <Button
            onClick={onCenterOperator}
            disabled={selectedOperator?.trackingEnd || !selectedOperator || routeDisabled}
            icon={getOperatorIcon(selectedOperator?.type)}
          />
        </Tooltip>
        <Tooltip title="Ajustar Zoom" placement="bottom">
          <Button onClick={onFit} disabled={fitDisabled} icon={<AimOutlined />} />
        </Tooltip>

        {!isFullScreen && (
          <Tooltip title="Tela Cheia" placement="bottom">
            <Button
              onClick={onToggleFullScreen}
              icon={<ExpandOutlined />}
              disabled={routeDisabled}
            />
          </Tooltip>
        )}
      </div>

      {eta && (
        <Tooltip title="Tempo estimado até o destino" placement="bottom">
          <div className="eta-indicator">
            <ClockCircleOutlined style={{ marginRight: 4 }} />
            {eta}
          </div>
        </Tooltip>
      )}
    </div>
  );
}

export default MapControls;
